import { PropsWithChildren } from "react";
import classnames from "classnames";

import styles from "./widget-context-toolbar.module.css";

type WidgetContextToolbarProps = {
  className?: string;
};

/**
 * CMS-styled bar that lays out a-la-carte widget controls (time range, station,
 * refresh, ...). It only owns layout/chrome; each control wires itself to the
 * surrounding {@link WidgetContextHost} (runtime + refresh contexts).
 *
 * Chrome-less by design: it blends into the header/title bar it sits in. Pass a
 * `className` for per-site tweaks (e.g. spacing, wrapping).
 */
export function WidgetContextToolbar({
  className,
  children,
}: PropsWithChildren<WidgetContextToolbarProps>) {
  return <div className={classnames(styles.toolbar, className)}>{children}</div>;
}
